export default __webpack_public_path__ + "static/media/image-4.48e1ce46.png";